/** Formats a wheel diameter in inches — 1 decimal, dropping a trailing
 *  ".0" so whole-inch values (26" at 100 %) read clean. One copy for
 *  the three consumers: joystick scale readout, v2 panel, header pill.
 *  The inch mark is the caller's — readouts differ on spacing. */
export function formatWheelDiameter(value: number): string {
  const oneDp = value.toFixed(1)
  return oneDp.endsWith('.0') ? oneDp.slice(0, -2) : oneDp
}
